
import React from "react";
import ViewTimetable from "../Faculty/ViewTimetable";
import { FiCalendar, FiInfo } from "react-icons/fi";

const Timetable = () => {
  return (
    <div className="space-y-6">
      <div className="bg-white dark:bg-slate-900 rounded-2xl border border-slate-200 dark:border-slate-800 shadow-xs overflow-hidden">
        {/* Header */}
        <div className="bento-header-banner flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="bg-indigo-50 dark:bg-indigo-950/60 border border-indigo-100 dark:border-indigo-800 p-2.5 rounded-xl text-indigo-600 dark:text-indigo-400">
              <FiCalendar className="text-xl" />
            </div>
            <div>
              <h1 className="text-xl font-bold tracking-tight text-slate-900 dark:text-white">Academic Timetable</h1>
              <p className="text-slate-500 dark:text-slate-400 text-xs mt-0.5">View scheduled lectures and laboratory sessions across branches</p>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="p-6 space-y-6">
          <div className="bg-indigo-50/60 dark:bg-indigo-950/40 border border-indigo-100 dark:border-indigo-800/80 rounded-2xl p-4 flex items-start gap-3">
            <FiInfo className="text-indigo-600 dark:text-indigo-400 text-base flex-shrink-0 mt-0.5" />
            <p className="text-xs text-indigo-950 dark:text-indigo-200">
              <strong>Notice:</strong> Timetable creation and assignments are managed by Academic Admins. Faculty can inspect branch schedules and individual faculty timetables here.
            </p>
          </div>

          <ViewTimetable />
        </div>
      </div>
    </div>
  );
};

export default Timetable;
